export const commit = 'COMMIT';
export const branch = 'BRANCH';
export const date = 'DATE';
export const version = branch.match(/release-(.*)/)?.[1] || commit;
